import api from './api.js'

// token请求
const client = process.env.AUTH_CLIENT
export function token(params){
    return api.post('/service-auth/oauth/token', {}, {params: client});
}
// 账号密码登录
export function getUserAndPassLogin(params){
    return api.post('/service-auth/oauth/login',params);
}
// 获取当前用户登录信息
export function getNewcurrent(params){
    return api.get('/service-center/api/v1/user/current',params);
}
// 文件上传
export function uploadFile(params){
    return api.post('/service-center/upload/file/single',params);
}
// 图片上传
export function uploadPicture(params){
    return api.post('/service-center/upload/file/single',params);
}
//获取字典值
export function getDictionaryItem(params){
    return api.get('/service-center/api/v1/dictionary/item',params);
}
export function getDictionaryGroup(params){
    return api.get('/service-center/api/v1/dictionary/group/list',params);
}
export function getDictionaryGroupTree(params){
    return api.get('/service-center/api/v1/dictionary/group/tree/list',params);
}
// 根据字典id查询字典详情
export function getDictionaryItemDetails(uuid){
    return api.get(`/service-center/api/v1/dictionary/item/${uuid}`);
}
export function getDictionaryListDetails(uuid){
    return api.get(`/service-center/api/v1/dictionary/group/${uuid}`);
}
export function getDictionaryInfo(code){
    return api.get(`/resource-portal/api/v1/wordInfo/getInfoByWordNo?wordNo=${code}`)
}
// 成果展示列表接口
export function getPresentationList(params){
    return api.get('/resource-print/api/v1/presentation/query',params);
}
// 成果展示添加接口
export function addPresentationList(params){
    return api.post('/resource-print/api/v1/presentation',params);
}
// 成果展示删除接口
export function delPresentationList(params){
    return api.get('/resource-print/api/v1/presentation/deletePresentationList',params);
}
// 成果展示查询详情
export function getPresentationDetail(params){
    return api.get('/resource-print/api/v1/presentation/findMaterialDetail',params);
}
// 成果展示修改
export function editPresentation(params){
    return api.post(`/resource-print/api/v1/presentation/${params.uuid}`,params);
}
// 成果发布
export function publishPresentation(params){
    return api.get(`/resource-print/api/v1/presentation/issuePresentationList`,params);
}
// 服务能力列表
export function getServiceList(params){
    return api.get('/resource-print/api/v1/serviceability/query',params);
}
// 服务能力添加接口
export function addServiceList(params){
    return api.post('/resource-print/api/v1/serviceability',params);
}

// 服务能力查询详情
export function getServiceDetail(params){
    return api.get('/resource-print/api/v1/serviceability/findMaterialDetail',params);
}
// 服务能力修改
export function editService(params){
    return api.post(`/resource-print/api/v1/serviceability/${params.uuid}`,params);
}
// 服务能力删除接口
export function delServiceList(params){
    return api.get('/resource-print/api/v1/serviceability/deleteServiceabilityList',params);
}

// 服务能力发布
export function publishServiceList(params){
    return api.get(`/resource-print/api/v1/serviceability/issueServiceabilityList`,params);
}

// 材料管理列表
export function getMaterialList(params){
    return api.get('/resource-print/api/v1/material/manager/query',params);
}
// 材料管理新增
export function addMaterialList(params){
    return api.post('/resource-print/api/v1/material/manager',params);
}
// 材料管理查询详情
export function getMaterialDetail(params){
    return api.get('/resource-print/api/v1/material/manager/findMaterialDetail',params);
}
// 材料管理修改
export function editMaterial(params){
    return api.post(`/resource-print/api/v1/material/manager/${params.uuid}`,params);
}
// 材料管理删除接口
export function delMaterialList(params){
    return api.get('/resource-print/api/v1/material/manager/deleteMaterialManagerList',params);
}
// 材料管理发布接口
export function publishMaterialList(params){
    return api.get(`/resource-print/api/v1/material/manager/issueMaterialManagerList`,params);
}

// 成果展示列表接口
export function getProductList(params){
    return api.get('/resource-design/api/v1/design/product/query',params);
}
// 成果展示添加接口
export function addProductList(params){
    return api.post('/resource-design/api/v1/design/product/save',params);
}
// 成果展示发布接口
export function releaseProductList(params){
    return api.post('/resource-design/api/v1/design/product/release',params);
}
// 成果展示删除接口
export function delProductList(params){
    return api.post('/resource-design/api/v1/design/product/delete',params);
}
// 成果展示详情接口
export function getProductDetail(params){
    return api.get(`/resource-design/api/v1/design/product/${params.uuid}`);
}
// 成果展示审批接口
export function examProductDetail(params){
    return api.get(`/resource-design/api/v1/design/product/exam/${params.uuid}`);
}

// 模型列表接口
export function getModelList(params){
    return api.get('/resource-design/api/v1/design/model/query',params);
}
// 模型添加接口
export function addModelList(params){
    return api.post('/resource-design/api/v1/design/model/save',params);
}
// 模型发布接口
export function releaseModelList(params){
    return api.post('/resource-design/api/v1/design/model/release',params);
}
// 模型删除接口
export function delModelList(params){
    return api.post('/resource-design/api/v1/design/model/delete',params);
}
// 模型详情接口
export function getModelDetail(params){
    return api.get(`/resource-design/api/v1/design/model/${params.uuid}`);
}
// 模型审批接口
export function examModelDetail(params){
    return api.get(`/resource-design/api/v1/design/model/exam/${params.uuid}`);
}

// 模型订单查询接口
export function getModelOrderList(params){
    return api.get('/resource-order/api/v1/order/model/query',params);
}
// 根据用户ID获取设计师信息
export function designerByUserId(userId){
    return api.get(`/resource-design/api/v1/designer/getByUserId/${userId}`);
}

// 更新设计师信息
export function updateDesigner(params){
    return api.post(`/resource-design/api/v1/designer/${params.uuid}`, params);
}

// 报价订单查询接口
export function getOfferOrderList(params){
    return api.get('/resource-design/api/v1/designer/order/query',params);
}

// 获取需求详情
export function demandDetail(id){
    return api.get('/resource-design/api/v1/demand/' + id);
}

// 设计师需求报价订单状态更新
export function updateODesignerOffer(params){
    return api.post('/resource-design/api/v1/designer/order/updateOffer',params);
}

// 获取模型订单详情
export function getModelOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/model/${params.uuid}`,params);
}

//保存回复
export function saveEvaluation(params){
    return api.post('/resource-order/api/v1/order/evaluation/save',params);
}

// 分页获取评价列表
export function getEvaluationList(params){
    return api.get(`/resource-order/api/v1/order/evaluation/sellerQuery`,params);
}

// 分页获取设计师-需求-模型关注-收藏列表
export function getCollectList(params){
    return api.get(`/resource-design/api/v1/designer/like/query`,params);
}
// 分页获取设计师-需求-模型关注-收藏列表Map
export function getCollectListByMap(params){
    return api.get(`/resource-design/api/v1/designer/like/queryMap`,params);
}
// 取消收藏设计师-需求-模型
export function deleteCollects(params){
    return api.post(`/resource-design/api/v1/designer/like/delete`,params);
}


//获取我的投诉列表
export function getOrderComplainList(params){
    return api.get('/resource-order/api/v1/order/complain/query',params);
}
// 设计师中心动态获取菜单
export function getMenuList(){
    return api.get('/service-center/api/v1/security/service/resource/self/designerCenterService');
}

// 收货地址查询详情
export function getAddressDetail(params){
    return api.get(`/service-center/api/v1/address/${params.uuid}`);
}

// 查询发票抬头详情
export function findInvoiceInfo(params){
    return api.get(`/service-center/api/v1/invoice/title/${params.uuid}`);
}

//获取售后申请列表
export function getAfterSaleList(params){
    return api.get('/resource-order/api/v1/order/afterSale/query',params);
}

// 提交售后审核
export function auditAfterSale(params){
    return api.post('/resource-order/api/v1/order/afterSale/audit',params);
}

// 设计订单列表
export function getDesignOrderList(params){
    return api.get('/resource-order/api/v1/order/design/proTable',params);
}

// 修改状态
export function updateDesignOrderStatus(params){
    return api.get('/resource-order/api/v1/order/design/updateDesignOrderStatus',params);
}

// 获取订单详情
export function getDesignOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/design/${params.uuid}`);
}

// 需求详情
export function getDesignInfoDetail(params){
    return api.get(`/resource-design/api/v1/demand/portal/${params.uuid}`);
}

// 查询参与报价的设计师
export function findDemandOfferList(params){
    return api.get('/resource-design/api/v1/demand/findDemandOffer',params);
}

// 查询文件列表
export function getDesignerDemandFile(params){
    return api.get('/resource-design/api/v1/designer/demand/getDesignerDemandFile',params);
}

// 查询文件列表
export function findUpdateList(params){
    return api.get('/resource-design/api/v1/designer/demand/findUpdateList',params);
}

// 保存设计文件
export function saveDesignerFile(params){
    return api.post('/resource-design/api/v1/designer/demand/saveDesignerFile',params);
}

// 添加修改意见
export function addUpdateRemark(params){
    return api.get('/resource-design/api/v1/designer/demand/addUpdateRemark',params);
}

// 获取融云token
export function getRongCloudToken(params){
    return api.get('/service-center/api/v1/rongcloud/getToken',params);
}

//（融云用）根据目标id获取用户或者企业管理员
export function getRongCloudUser(uuid){
    return api.get('/service-center/api/v1/user/rongCloud/' + uuid);
}

// 查询参与报价的设计师
export function findChooseDemandOffer(params){
    return api.get('/resource-design/api/v1/demand/findChooseDemandOffer',params);
}

// 查询文件列表
export function findUpdateRemark(params){
    return api.get('/resource-design/api/v1/designer/demand/findUpdateRemark',params);
}

// 获取设计订单
export function findAllDesignList(params){
    return api.get('/resource-order/api/v1/order/design/list',params);
}

// 获取订单数量
export function getDesignOrderCount(){
    return api.get('/resource-order/api/v1/order/design/getDesignOrderCount');
}

// 获取设计师banner
export function getDesignBanner(){
    return api.get('/resource-design/api/v1/banner/query');
}

// 保存设计师banner
export function saveDesignBanner(params){
    return api.post('/resource-design/api/v1/banner',params);
}

// 分页获取需求列表
export function demandListByPage(params){
    return api.get('/resource-design/api/v1/demand/query',params);
}
//工作台订单统计
export function getAllDesignOrderInfo(){
    return api.get('/resource-order/api/v1/order/design/getAllDesignOrderInfo');
}




// 测试
// 短信登录
export function getMessagesLogin(params){
    return api.post('/service-auth/sms/login',params);
}
// 获取安全校验码
export function getSecurityCode(params){
    return api.get('/service-auth/api/v2/validate/code',params);
}
// 点击获取短息
export function getSmscode(params){
    return api.get('/service-auth/api/v2/sms/code',params);
}
// 校验用户名是否存在
export function existsUserName(params){
    return api.get('/service-center/api/v1/security/account/exists',params);
}
// 忘记密码
export function editPassword(params){
    return api.put('/service-center/api/v2/security/account/password',params);
}
// 注册接口
export function getRegistered(params){
    return api.post('/service-auth/api/v2/register',params);
}

// 易宝开户
export function merchantApply(params){
    return api.post('/resource-pay/api/v1/yop/merchant/apply',params);
}
// 获取当前用户易宝开户信息
export function getMerchantInfo(params){
    return api.get('/resource-pay/api/v1/yop/merchant/current',params);
}

// 查询订单线下支付凭证
export function getOfflinePayTicket(orderNo){
    return api.get(`/resource-order/api/v1/order/base/getOfflinePayTicket/${orderNo}`);
}

// 线下支付订单确认支付完成
export function offlinePayConfirm(orderNo){
    return api.get(`/resource-order/api/v1/order/base/offlinePayConfirm/${orderNo}`);
}

// 获取结算订单列表
export function getBalanceList(params){
    return api.get('/resource-pay/api/v1/balance/query',params);
}

// 获取银行卡信息列表
export function getBankCardInfoList(params){
    return api.get('/resource-pay/api/v1/bankCard/query',params);
}
// 保存银行卡信息
export function saveBankCardInfo(params){
    return api.post('/resource-pay/api/v1/bankCard',params);
}
// 更新银行卡信息
export function updateBankCardInfo(params,uuid){
    return api.put('/resource-pay/api/v1/bankCard/'+uuid,params);
}
// 删除银行卡信息
export function deleteBankCardInfo(uuid){
    return api.del(`/resource-pay/api/v1/bankCard/${uuid}`);
}
// 获取银行卡信息
export function getBankCardInfo(uuid){
    return api.get(`/resource-pay/api/v1/bankCard/detail?uuid=${uuid}`,);
}

// 根据银行卡号获取银行卡相关信息
export function searchBankCarBinInfo(bankCardNo){
    return api.post(`/resource-pay/api/v1/bankCard/discriminate?bankCardNo=${bankCardNo}`,);
}

// 根据结算状态获取结算总金额
export function getTotalOrderBalanceByStatus(status){
    return api.get(`/resource-pay/api/v1/balance/totalPrice?status=${status}`,);
}
// 后去先行支付总金额
export function getPlatformPrice(){
    return api.get(`/resource-pay/api/v1/yop/order/platformPrice`,);
}

// 获取可提现金额
export function getCashOutBalance(){
    return api.get(`/resource-pay/api/v1/yop/merchant/surplus`,);
}

// 获取待结算总金额
export function getTotalNoneSplitPrice(){
    return api.get(`/resource-pay/api/v1/yop/order/totalNoneSplitPrice`,);
}

// 获取所有银行卡列表
export function getBankCardInfoTotalList(){
    return api.get(`/resource-pay/api/v1/bankCard/list`,);
}

// 获取未结算订单列表
export function getNoneSplitStatusList(params){
    return api.get('/resource-pay/api/v1/yop/order/getNoneSplitStatusList',params);
}

export function currentPageSettingInfo(){
    return api.get('/resource-print/api/v1/pageSetting/pageSettingInfo');
}

export function savePageSetting(params){
    return api.post('/resource-print/api/v1/pageSetting/save',params);
}

export function updatePageSetting(params){
    return api.post('/resource-print/api/v1/pageSetting/update',params);
}
// 获取设计师详情
export function designerViewDetail(id){
    return api.get('/resource-design/api/v1/designer/view/' + id);
}

// 获取销售总金额
export function getTotalSalesAmount(){
    return api.get(`/resource-order/api/v1/order/base/totalSalesAmount`,);
}

// 根据结算状态获取平台佣金
export function getTotalPortalFeeByStatus(status){
    return api.get(`/resource-pay/api/v1/balance/totalPortalFee?status=${status}`,);
}

//余额提现
export function cashOut(params){
    return api.post('/resource-pay/api/v1/yop/cash',params);
}

// 获取结算订单列表
export function getCashOutList(params){
    return api.get('/resource-pay/api/v1/yop/cash/query',params);
}

// 生成二维码接口
export function generateQrCode(parmas){
    return api.get('/service-auth/api/v1/qr/code',parmas);
}
// 获取扫码结果接口
export function scanCodeInfo(parmas){
    return api.get('/service-auth/api/v1/qr/code/info',parmas);
}
// 微信授权登录
export function weChatLogin(parmas){
    return api.get('/service-auth/api/v1/social/wechat',parmas);
}
// 微信登录账号绑定接口
export function weChatBind(parmas){
    return api.post('/service-auth/api/v1/social/wechat/bind',parmas);
}

//设计师再次入驻另一个身份
export function designerInAgain(params){
    return api.post('/resource-design/api/v1/designer/designerInAgain',params);
}
//添加结算卡
export function addSettledCard(param){
    return api.post('/resource-pay/api/v1/settled/card/add',param)
}

//查询结算卡
export function listSettledCard(param){
    return api.get('/resource-pay/api/v1/settled/card/list',param)
}

//修改结算方向
export function changeSettleWay(param){
    return api.post('/resource-pay/api/v1/settled/way/change',param)
}
// 查询当前用户是否开户完成、
export function merchantExists(){
    return api.get('/resource-pay/api/v1/yop/merchant/exists')
}



// WEBPACK FOOTER //
// ./src/utils/interface.js